//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { historyFlowList, leaveDetail } from "@/api/work/process";
import { completeTask } from "@/api/work/work";
export default {
  data: function data() {
    return {
      taskId: '',
      businessId: '',
      processInstanceId: '',
      src: '',
      flowList: [],
      form: {
        flow: {
          assigneeName: ''
        },
        startTime: '',
        endTime: '',
        reason: '',
        comment: ''
      }
    };
  },
  created: function created() {
    this.init();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // 在当前路由改变，但是该组件被复用时调用
    // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候
    // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用
    // 可以访问组件实例 `this`
    if (to.fullPath !== from.fullPath) {
      next();
      this.init();
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      this.taskId = this.$route.params.taskId;
      this.processInstanceId = this.$route.params.processInstanceId;
      this.businessId = this.$route.params.businessId;
      this.src = "/api/blade-flow/process/diagram-view?processInstanceId=".concat(this.$route.params.processInstanceId);
      historyFlowList(this.processInstanceId).then(function (res) {
        var data = res.data;

        if (data.success) {
          _this.flowList = data.data;
        }
      });
      leaveDetail(this.businessId).then(function (res) {
        var data = res.data;

        if (data.success) {
          _this.form = data.data;
        }
      });
    },
    handleAgree: function handleAgree() {
      var _this2 = this;

      if (!this.form.comment) {
        this.$message.warning('请先填写批复意见');
        return;
      }

      var params = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        flag: 'ok',
        comment: this.form.comment
      };
      completeTask(params).then(function (res) {
        var data = res.data;

        if (data.success) {
          _this2.$message.success(data.msg);

          _this2.$router.$avueRouter.closeTag();

          _this2.$router.push({
            path: "/work/start"
          });
        } else {
          _this2.$message.error(data.msg || '提交失败');
        }
      });
    },
    handleDisagree: function handleDisagree() {
      var _this3 = this;

      if (!this.form.comment) {
        this.$message.warning('请先填写批复意见');
        return;
      }

      var params = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        comment: this.form.comment
      };
      completeTask(params).then(function (res) {
        var data = res.data;

        if (data.success) {
          _this3.$message.success(data.msg);

          _this3.$router.$avueRouter.closeTag();

          _this3.$router.push({
            path: "/work/start"
          });
        } else {
          _this3.$message.error(data.msg || '提交失败');
        }
      });
    },
    handleCancel: function handleCancel() {
      this.$router.$avueRouter.closeTag();
      this.$router.push({
        path: "/work/start"
      });
    }
  }
};